import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 px-6 bg-[#F5F3EE]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Zone Titre */}
          <div className="lg:col-span-4 space-y-4">
            <h2 className="text-6xl font-black text-[#0A0A0A] leading-tight">
              Profil &<br />Parcours
            </h2>
            <p className="text-xl italic text-gray-600">
              {t('about.intro')}
            </p>
          </div>

          {/* Zone Contenu */}
          <div className="lg:col-span-8 space-y-8">
            {/* Carte Formation */}
            <div className="bg-[#ECECEC] rounded-3xl p-10">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-graduation-cap-line text-3xl text-[#0A0A0A]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A0A0A] mt-5 mb-4">Formation</h3>
              <ul className="space-y-3 text-base text-gray-700 leading-relaxed">
                <li className="flex items-start gap-3">
                  <span className="text-[#0066FF] mt-1">•</span>
                  <span>École du Code Sonatel Academy - Formation avancée en développement</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#0066FF] mt-1">•</span>
                  <span>Institut Polytechnique de Dakar - Deux années en ingénierie logicielle</span>
                </li>
              </ul>
            </div>

            {/* Carte Certifications */}
            <div className="bg-[#F0EBE3] rounded-3xl p-10">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-medal-line text-3xl text-[#0A0A0A]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A0A0A] mt-5 mb-4">Certifications</h3>
              <ul className="space-y-3 text-base text-gray-700 leading-relaxed">
                <li className="flex items-start gap-3">
                  <span className="text-[#0066FF] mt-1">•</span>
                  <span>Cisco Networking Academy - Certifications multiples</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#0066FF] mt-1">•</span>
                  <span>Commerce Numérique - Certification professionnelle</span>
                </li>
              </ul>
            </div>

            {/* Carte Expertise */}
            <div className="bg-[#E8E8E8] rounded-3xl p-10">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-code-s-slash-line text-3xl text-[#0A0A0A]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A0A0A] mt-5 mb-4">Expertise</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                {t('about.description')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
